import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ProfileData } from './DataDefinitions';

interface SideBarProps {
    profile?: ProfileData;
    onProfileChange: (name: string, value: any) => void;
}

const SideBar = ({
    profile,
    onProfileChange

}: SideBarProps) => {

    const { t } = useTranslation();

    const [isCoachChecked, setIsCoachChecked] = useState(profile?.is_coach === 'on');
    const [isMentorChecked, setIsMentorChecked] = useState(profile?.is_mentor === 'on');
    const [selectedCoachOptions, setSelectedCoachOptions] = useState<string[]>([]);
    const [selectedMentorOptions, setSelectedMentorOptions] = useState<string[]>([]);

    // Function to handle input changes
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        onProfileChange(name, value);
    };

    const handlecheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        onProfileChange(name, checked ? 'on' : 'off');
    };

    // Function to handle select changes
    const handleSelectInputChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name } = e.target;
        const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
        console.log(name + " " + selectedValues)
        onProfileChange(name, selectedValues.join(","));
    };

    const handleCoachSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
        onProfileChange('coach_types', selectedValues.join(", "));
        setSelectedCoachOptions(selectedValues);
    };

    const handleMentorSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValues = Array.from(event.target.selectedOptions, (option) => option.value);
        onProfileChange('mentor_types', selectedValues.join(", "));
        setSelectedMentorOptions(selectedValues);
    };

    useEffect(() => {
        if (profile && profile.coach_types)
            setSelectedCoachOptions(profile.coach_types.split(", ").map(item => item.trim()));

        if (profile && profile.mentor_types)
            setSelectedMentorOptions(profile.mentor_types.split(", ").map(item => item.trim()))
    }, []);


    return (
        <>
            <div className="pb-3">
                <h5 className="text-900 mb-3">{t("SideBar.describe_yourself")}</h5>

                <div className="d-flex p-2">
                    <Form.Check type="checkbox" id="showCoach" className='w-50'>
                        <Form.Check.Input
                            type="checkbox"
                            name="is_coach"
                            defaultChecked={isCoachChecked}
                            onChange={(event) => { setIsCoachChecked(event.target.checked); handlecheckboxChange(event); }}
                        />
                        <Form.Check.Label htmlFor="showCoach" className="fs-8">
                            {t("SideBar.i_am_a_coach")}
                        </Form.Check.Label>
                    </Form.Check>

                    <div className='w-50'>
                        {isCoachChecked && <h6 className="text-900 mb-3 ">{t("SideBar.multi_select")}</h6>}
                        <Form.Select aria-label="Default select example"
                            multiple={true}
                            disabled={!isCoachChecked}  // Conditionally enable/disable
                            onChange={handleCoachSelectChange}
                            value={selectedCoachOptions}
                        >
                            {/*<option>Open this select menu</option>*/}
                            <option value="ICF Certified">ICF Certified </option>
                            <option value="Career Coaching">Career Coaching</option>
                            <option value="Leadership Coaching">Leadership Coaching</option>
                            <option value="Team Coaching">Team Coaching</option>
                        </Form.Select>
                    </div>
                </div>

                <div className="d-flex p-2 mb-2">
                    <Form.Check type="checkbox" id="showMentor" className='w-50'>
                        <Form.Check.Input
                            type="checkbox"
                            name="is_mentor"
                            defaultChecked={isMentorChecked}
                            onChange={(event) => { setIsMentorChecked(event.target.checked); handlecheckboxChange(event); }}

                        />
                        <Form.Check.Label htmlFor="showMentor" className="fs-8">
                            {t("SideBar.i_am_a_mentor")}
                        </Form.Check.Label>
                    </Form.Check>
                    <div className='w-50'>
                        {isMentorChecked && <h6 className="text-900 mb-3 ">{t("SideBar.multi_select")}</h6>}

                        <Form.Select aria-label="Default select example"
                            multiple={true}
                            disabled={!isMentorChecked}  // Conditionally enable/disable
                            onChange={handleMentorSelectChange}
                            value={selectedMentorOptions}
                        >
                            {/*<option>Open this select menu</option>*/}
                            <option value="Career">Career</option>
                            <option value="Internal Mobility">Internal Mobility</option>
                            <option value="Leadership">Leadership</option>
                            <option value="Sales">Sales</option>
                            <option value="Shadow Mentoring">Shadow Mentoring</option>

                        </Form.Select>
                    </div>
                </div>
            </div>

            {isCoachChecked &&
                <>
                    <div className="pb-3">
                        <h5 className="text-900 mb-3">{t("SideBar.coaching_services")}</h5>
                        <Form.Select aria-label="Default select example"
                            multiple={true} name="services" id="services"
                            onChange={handleSelectInputChange}
                            value={profile?.services?.split(",")}
                        >
                            <option value="communication-skills">Communication skills</option>
                            <option value="job-career-change">Job/Career change</option>
                            <option value="leadership-development">Leadership development</option>
                            <option value="personal-growth">Personal growth</option>
                            <option value="strategic-thinking">Strategic thinking</option>
                            <option value="team-effectiveness">Team effectiveness</option>
                            <option value="work-life-balance">Work-life balance</option>

                        </Form.Select>
                    </div>

                    <div className="pb-3">
                        <h5 className="text-900 mb-3">{t("SideBar.coaching_method")}</h5>
                        <Form.Select aria-label="coaching method"
                            multiple={true} name="coaching_method" id="services"
                            onChange={handleSelectInputChange}
                            value={profile?.coaching_method?.split(",")}
                        >
                            <option value="in-person">In-person</option>
                            <option value="via-video-connection">Via video connection</option>

                        </Form.Select>
                    </div>



                </>
            }

            <div className="pb-3">
                <h5 className="text-900 mb-3">{t("SideBar.question1")}</h5>
                <Form.Control
                    id="question1"
                    as="textarea"
                    style={{ height: '115px' }}
                    type="text"
                    className="form-icon-input"
                    value={profile?.question1}
                    name="question1"
                    onChange={handleInputChange}
                />
            </div>

            <div className="pb-3">
                <h5 className="text-900 mb-3">{t("SideBar.question2")}</h5>
                <Form.Control
                    id="question2"
                    as="textarea"
                    style={{ height: '115px' }}
                    type="text"
                    className="form-icon-input"
                    value={profile?.question2}
                    name="question2"
                    onChange={handleInputChange}
                />
            </div>

            <div className="pb-3">
                <h5 className="text-900 mb-3">{t("SideBar.question3")}</h5>
                <Form.Control
                    id="question3"
                    as="textarea"
                    style={{ height: '115px' }}
                    type="text"
                    className="form-icon-input"
                    value={profile?.question3}
                    name="question3"
                    onChange={handleInputChange}
                />
            </div>

        </>
    );
};

export default SideBar;
